import { useState } from 'react';
import { resetDemo } from '../api';
import { DEMO_SEED_ADMIN_ALIAS, DEMO_SEED_ADMIN_PASSWORD } from '../demo-seed-credentials';
import { useDemoStore } from '../store/demo.store';

const PHASE_OPTIONS = [
  { value: '', label: 'Phase 0 (base vide)' },
  { value: 'phase-1', label: 'Phase 1 — Identité entreprise' },
  { value: 'phase-2', label: 'Phase 2 — Contexte' },
  { value: 'phase-3', label: 'Phase 3 — Cartographie' },
  { value: 'phase-4', label: 'Phase 4 — Fiches processus' },
  { value: 'phase-5', label: 'Phase 5 — Documents' },
  { value: 'phase-6', label: 'Phase 6 — Audits' },
  { value: 'phase-7', label: 'Phase 7 — Revue de direction' },
  { value: 'phase-8', label: 'Phase 8 — Pilotage / KPI' },
];

export function DemoBar() {
  const { enabled, status } = useDemoStore();
  const [target, setTarget] = useState<string>('');
  const [busy, setBusy] = useState(false);
  const [feedback, setFeedback] = useState<string | null>(null);

  if (!enabled) return null;

  const onReset = async () => {
    if (busy) return;
    if (!confirm('Confirmer ? Toutes les données démo vont être effacées et rechargées.')) return;
    setBusy(true);
    setFeedback(null);
    try {
      const res = await resetDemo({ phaseCode: target === '' ? null : target });
      const nextState = res.resetTo ?? 'phase 0 (wizard actif)';
      const loginHint =
        res.resetTo != null
          ? ` — connexion : ${DEMO_SEED_ADMIN_ALIAS} / ${DEMO_SEED_ADMIN_PASSWORD}`
          : '';
      setFeedback(`OK — état restauré : ${nextState}${loginHint}`);
      setTimeout(() => window.location.reload(), 600);
    } catch (err) {
      setFeedback(err instanceof Error ? err.message : 'Échec du reset');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="sticky top-0 z-50 w-full border-b border-amber-300 bg-amber-100/95 backdrop-blur">
      <div className="mx-auto flex max-w-6xl flex-col gap-2 px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-[0.78rem] font-semibold uppercase tracking-[0.16em] text-amber-900">
          Mode démo · Site actuel :{' '}
          <span className="font-bold">{status?.currentSitePhaseCode ?? 'phase 0 (wizard)'}</span>
        </p>
        <div className="flex flex-wrap items-center gap-2">
          <select
            className="rounded-md border border-amber-400 bg-white px-2 py-1 text-sm"
            value={target}
            onChange={(e) => setTarget(e.target.value)}
            disabled={busy}
          >
            {PHASE_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
          <button
            type="button"
            className="rounded-md bg-amber-700 px-3 py-1 text-sm font-semibold text-white hover:bg-amber-800 disabled:opacity-60"
            onClick={onReset}
            disabled={busy}
          >
            {busy ? 'Reset…' : 'Reset démo'}
          </button>
          {feedback && (
            <span className="text-[0.78rem] font-medium text-amber-900">{feedback}</span>
          )}
        </div>
      </div>
    </div>
  );
}
